import { render } from "./footerEN.vue?vue&type=template&id=f660543e&scoped=true"
import script from "./footerEN.vue?vue&type=script&lang=js"
export * from "./footerEN.vue?vue&type=script&lang=js"

import "./footerEN.vue?vue&type=style&index=0&id=f660543e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f660543e"]])

export default __exports__